import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SubscriptionBusinessService } from 'src/app/core/business/subscription/subscription-business.service';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionFacadeService {

  constructor(private subscriptionBusinessService: SubscriptionBusinessService) { }

  createCard(data: any): Observable<any> {
    return this.subscriptionBusinessService.createCard(data);
  }
  createSubscription(data: any): Observable<any> {
    return this.subscriptionBusinessService.createSubscription(data);
  }
  updateAutoRenewal(data: any): Observable<any> {
    return this.subscriptionBusinessService.updateAutoRenewal(data);
  }
  subscribeTrial(data: any): Observable<any> {
    return this.subscriptionBusinessService.subscribeTrial(data);
  }
  getPlanById(paramsReq) {
    return this.subscriptionBusinessService.getPlanById(paramsReq);
  }
  updateBillingAddress(data): Observable<any> {
    return this.subscriptionBusinessService.updateBillingAddress(data)
  }

  zipCodeValidation(data: any): Observable<any> {
    return this.subscriptionBusinessService.zipCodeValidation(data);
  }

  createMultipleLocation(data: any): Observable<any> {
    return this.subscriptionBusinessService.createMultipleLocation(data);
  }

  createMultipleStylist(data: any): Observable<any> {
    return this.subscriptionBusinessService.createMultipleStylist(data);
  }

  promoCodeValidation(data: any): Observable<any> {
    return this.subscriptionBusinessService.promoCodeValidation(data);
  }

  storeRpDetails(data: any): Observable<any> {
    return this.subscriptionBusinessService.storeRpDetails(data);
  }
}
